const maskField = (str: string, isMasked = false) => {
    if (isMasked) return "*".repeat(str.length);
    else return str;
};

export default maskField;
